import { InjectionToken } from '@angular/core';

/**
 * Image Resize Service URL
 * 개발 환경: https://images-resize-dev.sprintapp.team
 * 프로덕션: https://images-resize.sprintapp.team
 */
export const IMAGE_RESIZE_URL = new InjectionToken<string>(
  'IMAGE_RESIZE_URL',
  {
    providedIn: 'root',
    factory: () => 'https://images-resize.sprintapp.team', // 기본값
  }
);
